import origMoment from 'moment';
import { extendMoment } from 'moment-range';
const moment = extendMoment(origMoment);

export default moment;